import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {LoginService} from '../services/login.service';
import {Observable} from 'rxjs/Observable';
import {EventService} from '../services/event.service';

@Injectable()
export class AdminGuard implements CanActivate, CanActivateChild {

    constructor(private router: Router,
                private loginService: LoginService,
                private eventService: EventService) {
    }

    canActivate(route: ActivatedRouteSnapshot,
                state: RouterStateSnapshot): Observable<boolean> | boolean {
        const currentUser = this.loginService.getCurrentUser();
        if (currentUser.isLoggedIn && currentUser.admin) {
            return true;
        } else {
            this.router.navigate(['/home']);
            // this.notificationsService.warn('Warning', 'You need to have ADMIN rights to access this section');
            this.eventService.sendMessage({type: 'updateUser'});
            return false;
        }
    }

    canActivateChild(route: ActivatedRouteSnapshot,
                     state: RouterStateSnapshot): Observable<boolean> | boolean {
        return this.canActivate(route, state);
    }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/guards/admin.guard.ts